import { useState ,useEffect } from "react";
import { FaEnvelope } from "react-icons/fa";
import { IoCloseSharp } from "react-icons/io5";
import { Poppins } from "next/font/google";


export const poppins = Poppins({
  subsets: ["latin"],
  weight: ["400", "500", "600"],
    display: "swap",
});



const EnquiryFormPopup = () => {
  const [show, setShow] = useState(false);
  

  
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); 
     alert("Thank You For submit")
         e.currentTarget.reset();  
  };

  useEffect(() =>{
    setTimeout(() => {
        setShow(true)
    }, 10000);
     
  },[])
  return (
        <div className={poppins.className}>
      <button
        className="btn btn-warning enquiry-btn"
        onClick={() => setShow(true)}
      >
        <FaEnvelope className="me-2  envelope-bell" />
        Enquiry
      </button>

      
      {show && (
        <div className="modal fade show d-block" onClick={() =>setShow(false)}>
          <div className="modal-dialog enquiry-dialog col-lg-1"  onClick={(e) => e.stopPropagation()}>
                <div className={`modal-content enquiry-content ${poppins.className}`}>
                                                                                     
            
              <div className="modal-header enquiry-header d-flex justify-content-between">
                 <div className="d-flex align-items-center">
                     <FaEnvelope size={24} className="m-2 text-primary" />
                      <h6 className="modal-title">
                         Enquiry Form
                       </h6>
                 </div>
                
                <button
                  type="button"
                  className="enquiry-close"
                  onClick={() => setShow(false)}
                >
                    <IoCloseSharp size={25} className="me-2"/>
                </button>
              </div>

            
              <div className="modal-body enquiry-body">
                <form onSubmit={handleSubmit}>
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    className="form-control  mb-2"
                    placeholder="Enter your name"
                    required
                    pattern="[A-Za-z ]+"

                  />

                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    className="form-control mb-2"
                    placeholder="Enter your email"
                    required
                    pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"

                  />

                  <label htmlFor="phone">Phone Number</label>
                   <input
                       type="number"
                       id="phone"
                        className="form-control mb-2"
                         placeholder="Enter your phone number"
                         required
                        min="1000000000"
                        max="9999999999"
                      />

                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    className="form-control mb-2"
                    placeholder="Enter your enquiry"
                    required
                  ></textarea>

                  <button type="submit"  className="btn btn-warning w-100">
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
     
    </div>
  );
};

export default EnquiryFormPopup;
